/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketordernotfounderror4Inputs */

const en_ticketordernotfounderror4 = /** @type {(inputs: Ticketordernotfounderror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This order no longer exists.`)
};

const de_ticketordernotfounderror4 = /** @type {(inputs: Ticketordernotfounderror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Bestellung gibt es nicht mehr.`)
};

/**
* | output |
* | --- |
* | "This order no longer exists." |
*
* @param {Ticketordernotfounderror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketordernotfounderror4 = /** @type {((inputs?: Ticketordernotfounderror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketordernotfounderror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketordernotfounderror4(inputs)
	return de_ticketordernotfounderror4(inputs)
});
export { ticketordernotfounderror4 as "ticketOrderNotFoundError" }